import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import "../helpers/scroll-tracker";

gsap.registerPlugin(ScrollTrigger);

const totalOffsetTop = el => {
  if (el.offsetParent === document.body) return el.offsetTop;

  return el.offsetTop + totalOffsetTop(el.offsetParent);
}

class SubcollectionNavigation extends HTMLElement {
  constructor() {
    super();

    this.triggers = [];

    this._initLinkTriggers();
    this._integrateWithStickyHeader();
    window.refreshTriggers = () => this.triggers.forEach((trigger) => trigger.refresh());

    setTimeout(() => {
      this.triggers.forEach((trigger) => trigger.refresh());
    }, 4000);
  }

  _initLinkTriggers() {
    const setScrollOffset = () => {
      const offset = this.getBoundingClientRect().height;

      this.offset = offset;
    };

    setScrollOffset();

    window.addEventListener("resize", setScrollOffset);

    this.querySelectorAll("[data-subcollection-navigation-link]").forEach(
      (link) => {
        const targetId = link.dataset.subcollectionNavigationLink;

        const section = document.querySelector(`#${targetId}`);
        if (!section) return;

        link.addEventListener("click", (e) => {
          e.preventDefault();
          const targetTop = totalOffsetTop(section);
          const scrollUp = targetTop <= window.scrollY;
          const top = targetTop - this.offset;

          // Smooth scroll causes some quirks so add a "Close enough" deadband to avoid scrolling
          // when user clicks link multiple times.
          if (Math.abs(window.scrollY - top) < 100) return;

          window.headerIgnoreScroll = scrollUp;
          window.scroll({ top, left: 0, behavior: 'smooth' });
        });

        this.triggers.push(
          ScrollTrigger.create({
            trigger: section,
            start: "top 50%",
            end: "bottom 50%",
            onToggle: (self) => {
              link.classList.toggle("text-strong", self.isActive);

              if (self.isActive) {
                const { offsetLeft } = link;
                link.closest('.subcollection-navigation__links-list').scroll({ top: 0, left: offsetLeft, behavior: 'smooth' });
              }
            },
          })
        );
      }
    );
  }

  get headerHeight() {
    return document.querySelector('.header')?.offsetHeight || 0;
  }

  _integrateWithStickyHeader() {
    const shopifySection = this.closest(
      ".shopify-section--subcollection-navigation"
    );

    const header = document.querySelector(".header");

    const onToggle = (self) => {
      shopifySection.classList.toggle(
        "shopify-section--sticking",
        self.isActive
      );
    };

    ScrollTrigger.create({
      trigger: shopifySection,
      start: "top top+=2px",
      end: "max",
      onToggle,
    });
  }
}

if (!customElements.get("subcollection-navigation")) {
  customElements.define("subcollection-navigation", SubcollectionNavigation);
}
